import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Brands1 from "../components/brands/Brands1";
import "../components/services/Services.css";
import { FaArrowRight } from "react-icons/fa";

const About = () => {
  return (
    <div className="page-container" id="missionidd">

      {/* Breadcrumbs Section */}
      <div
        className="breadcrumbs-header paralax"
        style={{
          backgroundImage:
            "url('/images/header/about-isols.jpg')",
          backgroundSize: "contain",
          backgroundPosition: "0% 0%",
        }}
      >
        <ul className="half-filter">
          <li className="dark-filter relative">
            <h1 className="pull-right color-1 text-right">
              <b>About Us</b>
            </h1>
            <ul className="breadcrumbs pull-right">
              <li>
                <a href="/">home</a>
              </li>
              <li>
                <span className="separate">/</span>
              </li>
              <li>
                <span>About us</span>
              </li>
            </ul>
            <div className="cutBox cut-bottom"></div>
          </li>
          <li className="custom-filter"></li>
        </ul>
      </div>

      {/* About Section */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            {/* Left Content */}
            <div className="col-xs-12 col-sm-6">
              <div className="b-mod-heading wow fadeInDown">
                <p className="first-heading font-secondary">
                  Innovate First, Rule Next...
                </p>
                <h2 className="heading-line line-right customColor customPseudoElBg">
                  <strong>ISOLS Group</strong>
                </h2>
                <p className="second-heading font-additional">
                  ISOLS stands for 'Intuitive Souls', those who carry a
                  visionary & innovative dimension to perceive.
                  <br />
                  <br />
                  ISOLS Group a private limited corporation is a pioneering
                  enterprise excelling, expanding & evolving in technology and
                  digital marketing solutions & product innovations. Ever since
                  its inception, the Group has created a legacy of delivering
                  top-notch consistent industries solutions for solving their
                  problems. The Group has multiple off-shoots and sister brands
                  under it. The evolution and growth of the Group Company & its
                  brands is associated with a pool of highly passionate young,
                  dynamic & experienced professionals called as ISOLIANS who are
                  blended with an art of creativity and perfection.
                </p>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-xs-12 col-sm-6">
              <div className="img-brd-mod">
                <div className="brd"></div>
                <div className="img-cut">
                  <div className="cut"></div>
                  <img
                    src="/images/header/isols-about2.jpg"
                    className="img-responsive center-block"
                    alt="Isols group building"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Work Mantra */}
          <div className="row">
            <div className="b-services-holder1 clearfix">
              <div className="col-xs-12 col-sm-12 wow slideInLeft">
                <div className="b-services-item">
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Our Work Mantra = Innovation + Creativity + Quality
                    </h6>
                    <p>
                      Our overall work culture, management and respective
                      department leadership are the robust pillars that act as a
                      strong gateway for delivering an excellent experience to
                      our clients and solving their problems technologically &
                      digitally.
                      <br />
                      ISOLS stands for “INTUITIVE SOULS” that has the capability
                      to transcend from ordinary to less ordinary human beings
                      by invoking their latent potential within the most evolved
                      current era of technology & digital world.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
 </section>
 
      
        {/* Group Companies Section */}
        <div className="b-home-services serve" style={{ marginBottom: 0 }}>
          <div className="container-fluid">
            <div className="b-services-holder clearfix">
              {/* 1 */}
              <div className="col-xs-12 col-sm-4">
                <div className="b-services-item wow fadeInLeft">
                  <div className="services-icon">
                    <img
                      src="/images/group-icon/ist-favicon_old.PNG"
                      alt="Innovative Solution Technologies"
                      style={{ width: "40px" }}
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Innovative Solution Technologies
                    </h6>
                    <p>
                      Creating strong footprints in technology innovation. From
                      simple application to industry specific tech automation
                      solution.
                    </p>
                  </div>
                </div>
              </div>

              {/* 2 */}
              <div className="col-xs-12 col-sm-4">
                <div className="b-services-item">
                  <div className="services-icon">
                    <img
                      src="/images/group-icon/DIL.png"
                      alt="Digital India Leader"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Digital India Leader
                    </h6>
                    <p>
                      Industry Specific Digital Marketing Solutions and Products
                      to empower brand, business & reputation of StartUps, SMEs
                      and MNCs.
                    </p>
                  </div>
                </div>
              </div>

              {/* 3 */}
              <div className="col-xs-12 col-sm-4">
                <div className="b-services-item wow fadeInRight">
                  <div className="services-icon">
                    <img
                      src="/images/group-icon/india-digital-pay-logo.webp"
                      alt="India Digital Pay"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      India Digital Pay
                    </h6>
                    <p>
                      Empowering unorganised SMEs with personalised Digital
                      Payment App System. Helping businesses to be smart with
                      cashless digital payment system.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4 */}
              <div className="col-xs-12 col-sm-4">
                <div className="b-services-item wow fadeInRight">
                  <div className="services-icon">
                    <img
                      src="/images/group-icon/IIDTss.webp"
                      alt="Indian Institute of Digital Transformations"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Indian Institute of Digital Transformations
                    </h6>
                    <p>
                      Indian Institute of Digital Transformations (IIDTs) –
                      Empowering students, professionals & businesses with
                      Digital Marketing, AI, Cyber & Cloud skills
                    </p>
                  </div>
                </div>
              </div>

              {/* 5 */}
              <div className="col-xs-12 col-sm-4">
                <div className="b-services-item wow fadeInRight">
                  <div className="services-icon">
                    <img
                      src="/images/services_screen.png"
                      alt="Thirsty Hunter"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Thirsty Hunter
                    </h6>
                    <p>
                      StartUp incubator to support, incubate, mentor & realise
                      the young mind's innovation and disruption for creating
                      value to the life.
                    </p>
                  </div>
                </div>
              </div>

              {/* 6 */}
              <div className="col-xs-12 col-sm-4">
                <div className="b-services-item wow fadeInRight">
                  <div className="services-icon">
                    <img
                      src="/images/group-icon/BYO.png"
                      alt="Book You Online"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      Book You Online
                    </h6>
                    <p>
                      Serving robust, customised & strong cloud infrastructure,
                      cloud security & dedicated servers solutions for
                      determining company's success.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mission Vision Section */}
        <section className="section-about abut">
        <div id="mission-vision-values" style={{ paddingTop: "50px" }}></div>
        <div className="container-bg-additional relative clearfix">
        <div className="b-services-bg-filter customBgColor"></div> 
          <div className="b-featured-services">
            <div className="container">
              <div className="row">
                {/* Left */}
                <div className="col-xs-12 col-sm-7 col-md-6 col-lg-7">
                  <div className="featured-services-left wow slideInLeft">
                    <div className="b-f-s-info">
                      <h2 className="f-s-title">
                        Our Mission, Vision <br /> & Values
                      </h2>
                      <p>
                        We work with an ideology: 'Keep your clients happy & they
                        will keep you happy. We ensure our customer success by
                        delivering quality, timeliness, innovation, creativity,
                        transparency & integrity and excellent results.
                      </p>
                     <a
                                                                   href="/contact"
                                                                   className="btn btn-default-arrow btn-sm"
                                                                 >
                                                                   <FaArrowRight /> get in touch
                                           </a>
                    </div>
                  </div>
                </div>

                {/* Right */}
                <div className="col-xs-11 col-sm-5 col-md-5 col-lg-5">
                  <div className="bank featured-services-right wow fadeIn">
                    <div className="b-work-steps">
                      {/* Mission */}
                      <div className="b-services-item">
                        <div className="services-icon work-active">
                          <div className="circle-0">
                            <div className="circle-1">
                              <div className="circle-2"></div>
                            </div>
                          </div>
                        </div>
                        <div className="services-text">
                          <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                            <span className="customColor">-*-</span> Mission
                          </h6>
                          <p>
                            To provide an enriching optimistic work environment,
                            vibrant work culture and individual wellbeing for all
                            ISOLIANS by creating progressive benchmarks with
                            consistency to evolve the best quality, efficiency and
                            result oriented solutions, products & services for
                            various industries.
                          </p>
                        </div>
                      </div>

                      {/* Vision */}
                      <div className="b-services-item">
                        <div className="services-icon">
                          <div className="circle-0">
                            <div className="circle-1">
                              <div className="circle-2"></div>
                            </div>
                          </div>
                        </div>
                        <div className="services-text">
                          <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                            <span className="customColor">-*-</span> Vision
                          </h6>
                          <p>
                            Our vision is to simplify industries problems
                            technologically & digitally by innovating the edge
                            cutting solutions & products that can lead to
                            industrial transformation.
                          </p>
                        </div>
                      </div>

                      {/* Values */}
                      <div className="b-services-item">
                        <div className="services-icon">
                          <div className="circle-0">
                            <div className="circle-1">
                              <div className="circle-2"></div>
                            </div>
                          </div>
                        </div>
                        <div className="services-text">
                          <h6 className="services-title customPseudoElBg font-secondary text-uppercase">
                            <span className="customColor">-*-</span> Values
                          </h6>
                          <p>
                            Strong 'values and ethics' are the backbone of our
                            system that catalysis in expanding the intelligence
                            dimension of each ISOLIAN. Ever since the outset of
                            the Group Company, the visionary Founder 'Ujjwal
                            Chugh' has imbibed the values of ‘Great Karma’ in
                            each ISOLIAN, and has always inspired everyone to
                            work nonstop for ultimate success, happiness and
                            well-being.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Right */}
              </div>
            </div>
          </div>
        </div>
      </section>
       <section className="awards-recognitions ">
          <div className="container mx-auto px-4">
            <div className="row b-member-info">
                <div className="col-xs-12 col-sm-3">
                <div className="b-mod-heading">
                  <p className="first-heading font-secondary member-prof">Awards &</p>
                  <h4 className="heading-line line-right customColor customPseudoElBg member-name" >
                  <strong>Recognitions</strong>
                  </h4>
              </div>
                </div>
                <div className="col-xs-12 col-sm-9">
                 <div className="b-member-caption">
                      <h6 className="contact-info-title customPseudoElBg font-secondary">BEST TECHNOLOGY & DIGITAL COMPANY OF THE YEAR AWARD</h6>
                      <p>ISOLS Group has been awarded as the Best Technology and Digital Company 2021 Award by Topgallant Media.</p>
                  </div>
                </div>
              </div>
              <div className="row">
              <div className="col-xs-6 col-sm-3 text-center">
                  <div className="member-img">
                    <img src="/images/award/isols1.webp" className="img-responsive" loading="lazy" alt="awards" width="262px" height="260px" />
                  </div>
              </div>
              <div className="col-xs-6 col-sm-3 text-center">
                  <div className="member-img">
                    <img src="/images/award/award1.webp" className="img-responsive" loading="lazy" alt="awards" width="262px" height="260px" />
                  </div>
              </div>
              <div className="col-xs-6 col-sm-3 text-center">
                  <div className="member-img">
                    <img src="/images/award/award2.webp" className="img-responsive" loading="lazy" alt="awards" width="262px" height="260px" />
                  </div>
              </div>
              <div className="col-xs-6 col-sm-3 text-center">
                  <div className="member-img">
                    <img src="/images/award/award3.webp" className="img-responsive" loading="lazy" alt="awards" width="262px" height="260px" />
                  </div>
              </div>
              <div className="col-md-12">
              <div className="aboutt">
                <Link to="/award-certifications" className="btn btn-default-arrow btn-sm">
                <FaArrowRight />
                  Explore More
                </Link>
              </div>
              </div>
              </div>
            </div>
          </section>
<Brands1 />
    </div>
  );
};

export default About;
